<template>
  <div class="d-flex justify-center">
    <v-btn icon color="primary" large @click="viewDetails">
      <v-icon size="26">mdi-eye</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  methods: {
    viewDetails() {
      this.params.context.parentComponent.openDraftDADetails(this.params.data);
    },
  },
};
</script>
